'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HeadingProps {
  title: string;
  center?: boolean;
  uppercase?: boolean;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
    vector?: string;
  };
  color?: 'white' | 'black';
  subtitle?: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  visualTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export function Heading({
  title,
  className,
  tag = 'h2',
  center = false,
  color = 'black',
  uppercase = false,
  subtitle,
  visualTag,
}: HeadingProps) {
  const Tag = tag;

  return (
    <div
      className={cn(
        'ea-heading__container',
        'flex flex-col items-start justify-start',
        className?.container,
        center && 'items-center justify-center text-center',
        subtitle && 'gap-4 sm:gap-5 lg:gap-6',
      )}
    >
      {!!subtitle && (
        <p
          className={cn(
            'flex h-[25px] items-center justify-center bg-[#EFF4FF] px-2 text-xs font-bold uppercase text-black sm:h-[28px] sm:text-sm',
            'ea-heading__subtitle',
            'font-heading',
            className?.subtitle,
          )}
        >
          {subtitle}
        </p>
      )}
      <Tag
        data-ea-visual-tag={visualTag}
        dangerouslySetInnerHTML={{ __html: title }}
        className={cn(
          'relative z-[5] text-left font-medium tracking-tighter text-black',
          color === 'white' && 'text-white',
          center && 'text-center',
          uppercase && 'uppercase',
          visualTag ?? tag,
          className?.title,
          'ea-heading__title',
        )}
      />
    </div>
  );
}
